// ADL Needs section form field enum
export enum ADLNeedsFormField {
  ADL_NEEDS = 'adlNeeds',
  ADL_NEED_ID = 'adlNeedId',
  ADL_NEED_OBSERVATION_REFERENCE = 'adlNeedObservationReference',
  ADL_NEED_NAME = 'adlNeedName',
  ADL_NEED_NEW_NOTE = 'adlNeedNewNote',
  ADL_NEED_IS_ARCHIVED = 'adlNeedIsArchived',
  ADL_NEED_LAST_NOTE_TEXT = 'adlNeedLastNoteText',
  ADL_NEED_LAST_NOTE_AUTHOR = 'adlNeedLastNoteAuthor',
  ADL_NEED_LAST_NOTE_DATE = 'adlNeedLastNoteDate'
}
